<template>
  <div class="macro-processos-timeline pl-5 pr-5">
    <div class="box" v-for="(box, index) in timelineItems" :key="index">
      <div :class="`box-line ${box.status === 'completed' ? 'primary' : ''}`"></div>
      
      <div class="box-wrapper">
        <div :class="getCirculoClass(box.status)" class="circulo-fixed">
          <SGPIconComponent v-if="box.status === 'completed'" color="white">
            mdi-check
          </SGPIconComponent>
          <SGPIconComponent v-else-if="box.status === 'stoped'" color="white">
            mdi-backburger
          </SGPIconComponent>
          <SGPIconComponent v-else-if="box.status === 'current'" color="white" class="icon-current">
            mdi-play
          </SGPIconComponent>
        </div>
        
        <div class="box-content">
          <span class="titulo">{{ box.title }}</span>
          <span class="aging">{{ box.aging }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MacroProcessosTimeline',
  
  props: {
    timelineItems: {
      type: Array,
      required: true,
      default: () => []
    }
  },
  
  methods: {
    getCirculoClass(status) {
      const baseClass = 'circulo';
      const statusClasses = {
        completed: 'circulo-completed',
        stoped: 'circulo-stoped',
        current: 'circulo-current',
        incomplete: 'circulo-incomplete'
      };
      
      return `${baseClass} ${statusClasses[status] || ''}`;
    }
  }
}
</script>

<style lang="scss" scoped>
$primary: #E3262E;

.macro-processos-timeline {
  width: 100%;
  display: flex;
  align-items: flex-start;
  position: relative;
  min-height: 150px;
  margin-top: 30px;
  gap: 0;

  div.box {
    width: 100%;
    // position: relative;
    // display: flex;
    // flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;

    .box-line {
      content: "";
      height: 10px;
      width: 100%;
      background: #ccc;
      position: absolute;
      top: 25px;
      z-index: 1;
      left: 0;
      
      &.primary {
        background: $primary;
      }
    }

    &:last-child {
      width: 40px;
    }

    .box-wrapper {
      display: flex;
      flex-direction: column;
      max-width: 200px;
      align-items: right;
      font-size: 14px;
      width: 200px;
      text-align: center;

      &:first-child {
        text-align: left;
      }

      span {
        position: relative;
        max-width: 200px;
        display: block;
        left: -74px;
        font-weight: 500;
        color: $primary;
      }
    }

    div.circulo {
      position: inherit;
      width: 50px;
      height: 50px;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      border: 3px solid $primary;
      background: #fff;
      z-index: 3;
      
      &-completed {
        background: $primary;
      }
      
      &-stoped {
        border-color: #FB9C2D;
        background: #FB9C2D;
      }
      
      &-current {
        border-color: $primary;
        background: #fff;
        animation: pulse 2s infinite;
      }
      
      &-incomplete {
        border-color: #ccc;
        background: #ccc;
      }

      .icon-current {
        animation: playPulse 1.5s infinite;
      }
    }
  }
}

@keyframes pulse {
  0%, 100% {
    box-shadow: 0 0 0 0 rgba(227, 38, 46, 0.7);
  }
  50% {
    box-shadow: 0 0 0 10px rgba(227, 38, 46, 0);
  }
}

@keyframes playPulse {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.7;
    transform: scale(1.2);
  }
}
</style>
